import Typed from "typed.js";

export default Typed;
